import Topbar from "./components/topbar/Topbar";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Projects from "./components/projects/Projects";
import Contact from "./components/contact/Contact";
import Loading from "./components/loading/Loading";
import React, { useRef, useState, useEffect } from 'react';
import "./app.scss";

// todo
// download cv button sa contact us
// fix contact us
function App() {
    const prevScrollY = useRef(0);
    const [homeLoaded, setHomeLoaded] = useState(false);
    var tId;

    const Animate = (currentPos, posArrayTop, posArrayBot, scrollDown) => {
        //navbar hide
        if(scrollDown){
            document.getElementById("navbarTopContainer").classList.add('fadeOut');
            document.getElementById("navbarSmContainer").classList.add('fadeOut');
            clearTimeout(tId);
            tId = setTimeout(() => {
                document.getElementById("navbarTopContainer").classList.remove('fadeOut');
                document.getElementById("navbarSmContainer").classList.remove('fadeOut');
            }, 500);
            
        }
        else{
            document.getElementById("navbarTopContainer").classList.remove('fadeOut');
            document.getElementById("navbarSmContainer").classList.remove('fadeOut');
        }
        //jk logo
        if(posArrayTop[0] <=  window.innerHeight && posArrayBot[0] >= 0 ){
            const toLeft = document.querySelectorAll(".to-left");
            const toRight= document.querySelectorAll(".to-right");
            for (var i = 0; i < toLeft.length; i++) {
                toLeft[i].style.transform = 'translate(-50%, -50%) rotate('+currentPos/10+'deg) scale('+ (100 - currentPos/8) +'%)';
                toLeft[i].style.marginLeft = '-'+posArrayTop[0]*-1.25 +'px';
                toRight[i].style.transform= 'translate(-50%, -50%) rotate('+currentPos/10+'deg) scale('+ (100 - currentPos/8) +'%)'
                toRight[i].style.marginLeft = posArrayTop[0]*-1.25 +'px';
            }
        }
        //about image
        if(posArrayTop[1] <=  window.innerHeight && posArrayBot[1] >= 0 ){
            document.querySelectorAll(".about .img-front")[0].style.webkitClipPath = "inset("+(100-(currentPos/13))+"% 0px "+((currentPos/13)-25)+"% 0px)";
            document.querySelectorAll(".about .img-front")[0].style.clipPath = "inset("+(100-(currentPos/13))+"% 0px "+((currentPos/13)-25)+"% 0px)";
        }

    };
    const handleToggle = () => {
        document.getElementsByTagName("body")[0].classList.toggle("light-theme")
        document.getElementsByTagName("body")[0].classList.toggle("dark-theme")
        document.getElementById("app").classList.toggle("light-theme")
        document.getElementById("app").classList.toggle("dark-theme")
    }
    const onScroll = (e) => {
        const appContainer = document.getElementById("app");
        const currentScrollY  = appContainer.getBoundingClientRect().top * -1;
        var scrollDown = true;
        var currentPage = '';

        if(document.querySelectorAll('.nav-wrapper.collapse.show').length === 1){
            document.getElementById("navbar-toggler").click();
        }
        let posArrayTop = [
            Math.round(document.getElementById("home").getBoundingClientRect().top),
            Math.round(document.getElementById("about").getBoundingClientRect().top),
            Math.round(document.getElementById("projects").getBoundingClientRect().top),
            Math.round(document.getElementById("contact").getBoundingClientRect().top)
        ];
        let posArrayBot = [
            Math.round(document.getElementById("home").getBoundingClientRect().bottom),
            Math.round(document.getElementById("about").getBoundingClientRect().bottom),
            Math.round(document.getElementById("projects").getBoundingClientRect().bottom),
            Math.round(document.getElementById("contact").getBoundingClientRect().bottom)
        ];
        if (prevScrollY.current < currentScrollY) {
            scrollDown = true;
            if(posArrayBot[0] > (window.innerHeight/3)){ currentPage = "section-home" }
            else if(posArrayBot[1] > (window.innerHeight/3)){ currentPage = "section-about" }
            else if(posArrayBot[2] > (window.innerHeight/3)){ currentPage = "section-projects" }
            else if(posArrayBot[3] > (window.innerHeight/3)){ currentPage = "section-contact" }
            else{currentPage = null}
        }
        if (prevScrollY.current > currentScrollY) {
            scrollDown = false;
            if(posArrayTop[3] < (window.innerHeight/3)){ currentPage = "section-contact" }
            else if(posArrayTop[2] < (window.innerHeight/3)){ currentPage = "section-projects" }
            else if(posArrayTop[1] < (window.innerHeight/3)){ currentPage = "section-about" }
            else if(posArrayTop[0] < (window.innerHeight/3)){ currentPage = "section-home" }
            else{currentPage = null}
        }
        toggleActive(currentPage);
        prevScrollY.current = currentScrollY;
        Animate(currentScrollY, posArrayTop, posArrayBot, scrollDown);
    };
    
    let timer = null;
    const toggleActive  = (elem)  =>{
        if(timer !== null) {
            clearTimeout(timer);        
        }
        if(elem !== null && elem !== undefined && elem !== ''){
            timer = setTimeout(function() {
                try{
                    document.getElementById("navbarTop").getElementsByClassName("active")[0].classList.remove('active')
                    document.getElementById(elem).classList.add('active')
                }
                catch(e){
                }
            }, 40);
        }
    }
    
    useEffect(() => {
        document.body.onscroll = (e) => {
            onScroll(e)
        }
        // eslint-disable-next-line
    }, [])
    
    if(homeLoaded && document.getElementById("app") != null){
        document.getElementById("app").style.height = null;
        document.getElementById("app").style.overflow = null;
    }
    return (
        <div className="app dark-theme" id="app" data-spy="scroll" data-target="#sections" style={{overflow:'hidden',height:"100vh"}}>
            <Loading imageLoaded={homeLoaded}/>
            <Topbar/>
            <div className="sections" id="sections" >
                <Home setHomeLoaded={setHomeLoaded}/>
                <About/>
                <Projects/>
                <Contact/>
            </div>
            <div className="toggle normal dark-light">
                <input id="normal" type="checkbox" onChange={() => handleToggle()}/>
                <label className="toggle-item" htmlFor="normal"></label>
            </div>
            <span className="footer-last-update">Last Update: August 2026</span>
        </div>
    );
}

export default App;
